const TUTORIAL_VIDEOS_BASE_URL = "https://june-tutorial-videos.s3.us-east-1.amazonaws.com";

/**
 * Product folders inside the tutorial-videos bucket.
 * SHARED holds videos reused by more than one product.
 */
export const TUTORIAL_VIDEO_FOLDER = {
  SHARED: "shared",
  JUNE: "june",
  DOCGEN: "docgen",
  DRM: "drm",
};

/**
 * Builds the public URL of a tutorial video.
 *
 * The current bucket stores every video at its root, so `folder` is not part
 * of the URL yet; prefix `${folder}/` once videos move to per-product folders.
 *
 * @param {string} folder - Bucket folder, use a TUTORIAL_VIDEO_FOLDER value.
 * @param {string} fileName - Object name as stored in S3, already URL-encoded
 *   (spaces as "+", "&" as "%26"), e.g. "1449+%26+892.mp4".
 * @returns {string} Absolute URL to the video file.
 */
export const tutorialVideoUrl = (folder, fileName) =>
  `${TUTORIAL_VIDEOS_BASE_URL}/${fileName}`;
